import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';

// Em produção, usa path relativo /api (nginx faz o proxy)
// Em desenvolvimento, usa a URL completa da variável de ambiente
const getBaseURL = () => {
  // Se tiver variável de ambiente definida, usa ela
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Em produção (sem variável), usa path relativo
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  // Fallback para desenvolvimento local
  return 'http://localhost:3339/api';
};

// Cria instância do axios com a URL base da API
const api = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar o token de autenticação
api.interceptors.request.use((config) => {
  const token = secureLocalStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      secureLocalStorage.removeItem('token');
      secureLocalStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
